import { COLORS } from 'assets/styled';
import styled from 'styled-components';
import { respondTo } from 'assets/styled/breakpoints';

interface StyledProps {
  fontSize: string;
}

export const LinkValue = styled.a`
  font-weight: 300;
  font-size: 16rem;
  text-decoration: underline;
  cursor: pointer;
  color: ${COLORS.BLACK};
`;
export const ValueLabel = styled.span`
  font-weight: 300;
  color: ${COLORS.BLACK};
  font-size: ${(props: StyledProps) =>
    props.fontSize ? props.fontSize : '16rem'};

  ${respondTo.bigPhone`
    font-size: 16rem;
  `}
`;
